import { Component } from '@angular/core';

@Component({
  selector: 'app-natural-person-or-no-profile-found',
  templateUrl: './natural-person-or-no-profile-found.component.html',
  styleUrls: ['./natural-person-or-no-profile-found.component.scss']
})
export class NaturalPersonOrNoProfileFoundComponent {

}
